import type { FC } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import useUserDataProvider from "src/contexts/userData-context";

interface TopAdminProps {
  onMobileNavOpen?: () => void;
}

export const TopAdmin: FC<TopAdminProps> = () => {
  const { userData } = useUserDataProvider();

  return (
    <Box
      component="header"
      sx={{
        position: "fixed",

        top: 0,
        width: `100%`,
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#418f56",
          py: 0.7,
          color: "primary.contrastText",
          height: "48px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container maxWidth={"lg"} sx={{ height: "100%" }}>
          <Stack
            direction="row"
            spacing={2}
            alignItems={"center"}
            textAlign={"left"}
            justifyContent={"center"}
            sx={{ height: "100%" }}
          >
            <Typography variant="button" sx={{ textTransform: "none" }}>
              {`You are viewing and contributing to ${userData?.full_name}'s plan.`}
            </Typography>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
};

TopAdmin.propTypes = {
  onMobileNavOpen: PropTypes.func,
};
